import React from 'react';
import type { FormValues } from '../../../../../../../../primeX-underwriter/modals/coverageLineItemModals/AdditionalInsuredModal';
import AdditionalInsuredModal from '../../../../../../../../primeX-underwriter/modals/coverageLineItemModals/AdditionalInsuredModal';
import {
  formatAIForState,
  getDefaultAIFields,
} from '../../amendatory-coverages/line-items/AdditionalInsureds';
import type {
  AI,
  RaterXCoverage,
} from '../../../../../../api/types/rater-x-preset';
import type { UpdateCoveragePayload } from '../../../../../../reducer';
import type { Languages } from '../../../../../../../../../../i18n/i18n.language-config';

const RaterXAdditionalInsuredsModal = ({ data, close }: ModalProps) => {
  const onSubmit = (formValues: FormValues) => {
    const _ai = formatAIForState(formValues);

    data.setCoverage({
      id: data.coverageState.id,
      isSelected: true,
      value: {
        props: {
          additionalInsureds: { values: _ai as unknown as AI[] },
        },
      },
    });
  };

  return (
    <AdditionalInsuredModal
      close={close}
      data={{
        onSubmit,
        additionalInsureds: getDefaultAIFields(
          data?.coverageState.value.props.additionalInsureds?.values as AI[]
        ),
        language: data.language,
      }}
    />
  );
};

type ModalProps = {
  data: {
    coverageState: RaterXCoverage;
    setCoverage: (payload: UpdateCoveragePayload) => void;
    language: Languages;
  };
  close: () => void;
};

export const RaterXAdditionalInsuredsModalConfig = {
  RaterXAdditionalInsuredsModal: {
    component: RaterXAdditionalInsuredsModal,
    config: {
      title: 'Additional Insureds',
      fullWidth: true,
      maxWidth: 'md',
    },
  },
};
